import { Link } from '@atoms/index';

export type DetailsProps = {
  summary?: string | React.ReactNode;
  content?: string | React.ReactNode;
};

export const Details = ({ summary, content }: DetailsProps) => {
  return (
    <details>
      <summary className="text-body text-action-link relative list-item w-fit cursor-pointer items-center rounded !pl-[3px] underline underline-offset-2 outline-2 outline-offset-0 outline-inherit hover:decoration-auto">
        {summary}
      </summary>
      <div className="text-body pl-inset border-l-sm border-action-button bg-background-paper mt-3 rounded p-2">
        {content}
      </div>
    </details>
  );
};

Details.displayName = 'Details';

export const CallThePoliceDetailsContent = () => (
  <p>
    If you have a hearing or speech impairment, use their textphone service
    18001 101.
  </p>
);

export const CallWCCDetailsContent = () => (
  <div>
    <p>
      British Sign Language users can contact us using a British Sign Language
      interpreter through the InterpretersLive! service, provided by Sign
      Solutions.
    </p>
    <p>7 days a week, 365 days a year</p>
    <p>This is a free service</p>
    <Link
      href="https://connect.interpreterslive.co.uk/vrs?ilc=CityOfWestminster"
      linkType="inline"
      external
      className="font-normal"
    >
      Go to InterpretersLive! website
    </Link>
  </div>
);

export const EvCallUsDetailsContent = () => (
  <div>
    <p>
      You can contact us using a British Sign Language (BSL) interpreter through
      the InterpretersLive! service, provided by Sign Solutions.
    </p>
    <br />
    <p>
      Find out how to{' '}
      <Link
        href="https://www.interpreterslive.co.uk/faq/"
        className="font-normal"
        linkType="inline"
        external
      >
        use the video relay service on the InterpretersLive! website.{' '}
      </Link>
    </p>
    <p>24-hour.</p>
    <p>This is a free service.</p>
    <br />
    <Link
      href="https://connect.interpreterslive.co.uk/vrs?ilc=CityOfWestminster"
      className="font-normal"
      linkType="inline"
      external
    >
      Connect to InterpretersLive!
    </Link>
  </div>
);

export const DefaultCallUsContentBody = () => (
  <div className="text-bodyLg flex flex-col gap-4">
    <div>
      <p>
        <strong>By phone</strong>:{` `}020 7641 2000
      </p>
      <p>24-hour service</p>
      <p>Standard call charges apply.</p>
      <p>
        Find out more about call charges on{' '}
        <Link
          href="https://www.gov.uk/call-charges"
          className="text-action-link font-normal underline"
          linkType="inline"
          title="Opens in a new tab"
          external={true}
        >
          GOV.UK
        </Link>
        .
      </p>
    </div>
  </div>
);

export const DefaultCallUsBottomLink = () => (
  <Details
    summary="Support contacting us if you have a hearing or speech impairment"
    content={<CallWCCDetailsContent />}
  />
);
